import { FetchStatus } from '@powdr/constants';

import { TRAFFIC_PENDING, TRAFFIC_SUCCESS, TRAFFIC_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRAFFIC_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case TRAFFIC_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case TRAFFIC_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
